import { CloudDownloadOutlined } from '@ant-design/icons'
import { Spin, Table, Tabs, Typography } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import { rcpGetNumUrl, rcpRecuperarUrl } from '../../../api/apiUrl'
import { useAxiosTna } from '../../../hooks/useAxiosTna'
import { configType } from '../../../types/configType'
import { msgType } from '../../../types/msgType'
import { notifyType } from '../../../types/notifyType'
import { downloadFile, viewerFile } from '../../../utils/fileUtil'
import { formatAmount, formatCamelCase, formatDate, formatTime } from '../../../utils/formatUtil'
import { setLastAccess } from '../../../utils/lstorageUtil'
import { NotifyRed } from '../../Msg/NotifyRed'

import './DetalleRcp.css'

var jszip = require('jszip')

export const DetalleRcp = (props) => {
    const { rcpt: rcptDB, numRE } = props

    const { axiosTnaGet } = useAxiosTna()
    const notifyRedRef = useRef()
    const [loadPage, setLoadPage] = useState(true)
    const [attachedFiles, setAttachedFiles] = useState([])
    const [bills, setBills] = useState([])
    const [currentLineFI, setCurrentLineFI] = useState(null)
    const [loadCargarRcp, setLoadCargarRcp] = useState(false)
    const [rcpDB, setRcpDB] = useState(null)

    useEffect(() => {
        let isMounted = true

        isMounted && setLoadPage(loadCargarRcp)

        return () => {
            isMounted = false
        }
    }, [loadCargarRcp])

    useEffect(() => {
        let isMounted = true

        const getRcp = async () => {
            let err = null
            let data = null

            setLoadCargarRcp(true)

            const url = rcpGetNumUrl(rcptDB.ruc, numRE)
            const [data_api, err_api] = await axiosTnaGet(url)
            data = data_api
            err = err_api

            if (data && isMounted) {
                const { success, data: rcp } = data
                if (success) {
                    setRcpDB(rcp)
                    if (rcp.attach)
                        setAttachedFiles(() => {
                            const files = rcp.attach.map(file => ({ ...file, key: file.dataOrder }))
                            files.sort(sortAttach)
                            return files
                        })
                    if (rcp.comprobante)
                        setBills(() => {
                            const docs = rcp.comprobante.map(doc => ({ ...doc, key: `${doc.tipoComprobanteID}-${doc.serie}-${doc.numero}` }))
                            docs.sort(sortCpe)
                            return docs
                        })
                }
            }
            if (err)
                notifyRedRef.current.handleOpen(err, notifyType.error)
            setLoadCargarRcp(false)
        }

        if (numRE)
            getRcp()

        return () => {
            isMounted = false
        }
        // eslint-disable-next-line
    }, [rcptDB, numRE])

    const sortAttach = (a, b) => {
        if (a.dataOrder > b.dataOrder)
            return 1
        else if (a.dataOrder < b.dataOrder)
            return -1
        else
            return -1
    }

    const sortCpe = (a, b) => {
        if (a.serie > b.serie)
            return 1
        else if (a.serie < b.serie)
            return -1
        if (a.numero > b.numero)
            return 1
        else
            return -1
    }

    const handleDownFile = async (record, download) => {
        let err = null
        let data = null

        setCurrentLineFI(record.dataOrder)

        const url = rcpRecuperarUrl(rcpDB.id, record.dataOrder)
        const [data_api, err_api] = await axiosTnaGet(url)
        data = data_api
        err = err_api

        if (data) {
            try {
                const { document } = data
                const zip = new jszip()
                const zresult = await zip.loadAsync(document, { base64: true })
                const unzip = await zresult.file(record.fileName).async('base64')
                if (!download && record.contentType === configType.contentTypePDF)
                    viewerFile(unzip, record.contentType, record.fileName)
                else
                    downloadFile(unzip, record.contentType, record.fileName)
            }
            catch (error) {
                err = {
                    message: msgType.apiError,
                    detail: error.message,
                    oops: true
                }
            }
        }
        if (err)
            notifyRedRef.current.handleOpen(err, notifyType.error)

        setCurrentLineFI(null)
        setLastAccess()
    }

    const fiColumns = [
        {
            title: 'Archivo',
            dataIndex: 'dataOrder',
            render: (_, record) =>
                <div className='flex items-center'>
                    <button
                        className='text-blue-600 w-full text-left'
                        disabled={record.dataOrder === currentLineFI}
                        onClick={() => handleDownFile(record, false)}
                    >
                        {`${record.fileName}`}
                    </button>
                    <div className='flex justify-end'>
                        {
                            record.dataOrder !== currentLineFI &&
                            <button className='mr-1' onClick={() => handleDownFile(record, true)}>
                                <CloudDownloadOutlined />
                            </button>
                        }
                        {
                            record.dataOrder === currentLineFI &&
                            <Spin size='small' className='mr-1' />
                        }
                    </div>
                </div>
        },
    ]

    const cpColumns = [
        {
            title: 'Documento',
            dataIndex: 'documento',
            width: 150,
            render: (_, record) => <span>{`${record.serie}-${record.numero}`}</span>
        },
        {
            title: 'Monto',
            dataIndex: 'totCpe',
            width: 120,
            align: 'right',
            render: (_, record) => <span>{formatAmount(record.totCpe)}</span>
        },
    ]

    return (
        <>
            <NotifyRed ref={notifyRedRef} />
            {
                loadPage &&
                <div className='my-5 flex justify-center'>
                    <Spin tip='Loading....' />
                </div>
            }
            {
                rcpDB &&
                <>
                    <div className='detallercp-data text-xs font-normal text-gray-900'>
                        {
                            rcpDB.emisor &&
                            <>
                                <p><span>{`RUC: `}</span>{`${rcpDB.emisor.ruc}`}</p>
                                <p><span>{`Emisor: `}</span>{`${rcpDB.emisor.name}`}</p>
                            </>
                        }
                        <div className="flex items-center">
                            <p><span>{`Nº de documento: `}</span>{`${rcpDB.numRE}`}</p>
                            <p className="p-0.5 text-xs ml-1 text-indigo-600">
                                {`${rcpDB.estado}`}
                            </p>
                        </div>
                        <p><span>{`Fecha de recibo: `}</span>{`${formatDate(rcpDB.fechaRecibo)}`}</p>
                        {
                            rcptDB &&
                            <>
                                <p><span>{`RUC: `}</span>{`${rcptDB.ruc}`}</p>
                                <p><span>{`Receptor: `}</span>{`${rcptDB.name}`}</p>
                            </>
                        }
                        <p><span>{`Moneda: `}</span>{`${rcpDB.monedaISO}`}</p>
                        <p><span>{`Total: `}</span>{`${formatAmount(rcpDB.total)}`}</p>
                        <p><span>{`Total facturado: `}</span>{`${formatAmount(rcpDB.totCpe)}`}</p>
                        <p><span>{`Doc. de proveedor: `}</span>{`${rcpDB.numDocProv ?? ''}`}</p>
                    </div>
                    <div className='detallercp-data-adi mt-1.5 text-xs font-normal text-gray-900'>
                        <p><span>{`${formatCamelCase(rcptDB?.grpName ?? '')}: `}</span>{`${rcpDB.grupo}`}</p>
                        <p><span>{`Fecha de registro: `}</span>{`${formatTime(rcpDB.fechaRegistro)}`}</p>
                    </div>
                    <Tabs
                        defaultActiveKey="1"
                        items={[
                            {
                                label: `Adjunto`,
                                key: '1',
                                children:
                                    attachedFiles.length > 0 ?
                                        <div className='detallercp-tabla'>
                                            <Table
                                                columns={fiColumns}
                                                dataSource={attachedFiles}
                                                pagination={false}
                                                bordered
                                                size='small'
                                            />
                                        </div>
                                        : <span></span>
                            },
                            {
                                label: `Comprobante`,
                                key: '2',
                                children:
                                    bills.length > 0 ?
                                        <div className='max-w-xs flex'>
                                            <div className='detallercp-tabla'>
                                                <Table
                                                    columns={cpColumns}
                                                    dataSource={bills}
                                                    pagination={false}
                                                    bordered
                                                    size='small'
                                                    summary={(pageData) => {
                                                        let totalCpe = 0.0
                                                        pageData.forEach(({ totCpe }) => {
                                                            totalCpe += totCpe
                                                        })
                                                        return (
                                                            <>
                                                                <Table.Summary.Row>
                                                                    <Table.Summary.Cell index={0}>Total</Table.Summary.Cell>
                                                                    <Table.Summary.Cell index={1} align='right'>
                                                                        <Typography.Text type='danger'>{formatAmount(totalCpe)}</Typography.Text>
                                                                    </Table.Summary.Cell>
                                                                </Table.Summary.Row>
                                                            </>
                                                        )
                                                    }}
                                                />
                                            </div>
                                            <span></span>
                                        </div>
                                        : <span></span>
                            },
                        ]}
                    />
                </>
            }
        </>
    )
}
